<script setup lang="ts">
import { computed, ref, useTemplateRef, watch } from 'vue'

import { Box, Button, Modal } from '@collector/shared-ui'
import { useIncidentsToConfirm } from '@desktop/views/Relation/components/RelationView/Main/IncidentsToConfirm/useIncidentsToConfirm'
import BetStatusButton from '@desktop/views/Relation/Sports/components/RelationView/Main/PocketIncidents/BetButton/BetStatusButton.vue'
import { useResizeObserver } from '@vueuse/core'

import ConfirmBaseballIncident from './ConfirmBaseballIncident.vue'

// composables
const { homeIncidentsTbd, awayIncidentsTbd } = useIncidentsToConfirm()

// state
const isMoreVisible = ref(false)
const isModalVisible = ref(false)
const wrapper = useTemplateRef('wrapper')

// computed
const incidentsTbd = computed(() => [
  ...homeIncidentsTbd.value,
  ...awayIncidentsTbd.value,
])

// methods
function updateIsMoreVisible(el: Element): void {
  if (el.scrollWidth > el.clientWidth) {
    isMoreVisible.value = true
  } else {
    isMoreVisible.value = false
  }
}

// init
useResizeObserver(wrapper, (entries) => {
  const entry = entries[0]

  updateIsMoreVisible(entry.target)
})

watch(
  incidentsTbd,
  () => {
    if (wrapper.value) {
      updateIsMoreVisible(wrapper.value)
    }
  },
  { flush: 'post' },
)
</script>

<template>
  <Box class="grid grid-cols-[auto_1fr] gap-x-3 px-4">
    <BetStatusButton class="w-full min-w-36 @lg:min-w-70" />
    <div
      ref="wrapper"
      class="relative flex gap-x-2 overflow-x-hidden"
    >
      <div
        v-if="!incidentsTbd.length"
        class="flex items-center text-sm"
      >
        The are no incidents to confirm
      </div>
      <ConfirmBaseballIncident
        v-for="incident in incidentsTbd"
        v-else
        :key="incident.id"
        :incident
      />
      <div
        v-if="isMoreVisible"
        class="bg-neutral-light-9 absolute top-0 right-0 pl-2"
      >
        <Button
          class="text-xs font-bold"
          variant="action"
          size="sm"
          width="slim"
          @click="isModalVisible = true"
        >
          More
        </Button>
      </div>
    </div>
  </Box>
  <Modal
    v-if="isModalVisible"
    title="Incidents to confirm"
    @close="isModalVisible = false"
  >
    <div class="mx-auto w-30 space-y-2">
      <ConfirmBaseballIncident
        v-for="incident in incidentsTbd"
        :key="incident.id"
        :incident
      />
    </div>
  </Modal>
</template>
